import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalNotificationHandler"] */ "/app/components/global-notification-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/contexts/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CeleryWebSocketProvider"] */ "/app/contexts/celery-websocket-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationsProvider"] */ "/app/contexts/notifications-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.0.7_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"_geist\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.0.7_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"_geistMono\"}");
